/**
 * Format a date as YYYY-MM-DD in local time.
 * Use this instead of date.toISOString().split("T")[0] to avoid UTC shift.
 * @param {Date} date
 * @returns {string}
 */
export const formatDateLocal = (date) => {
  const d = new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

/**
 * Parse YYYY-MM-DD as local date (avoids UTC midnight interpretation).
 * @param {string} str
 * @returns {Date}
 */
export const parseDateLocal = (str) => {
  if (!str || typeof str !== "string") return new Date(NaN);
  const parts = str.trim().split("-").map(Number);
  if (parts.length !== 3) return new Date(NaN);
  const [y, m, d] = parts;
  return new Date(y, m - 1, d, 0, 0, 0, 0);
};
